import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AddressesEffects } from './store/address-mercury.effects';
import * as fromAddresses from './store/address-mercury.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(fromAddresses.storeFeatureKey, fromAddresses.reducer),
    EffectsModule.forFeature([AddressesEffects]),
  ],
})
export class AddressMercuryStoreModule {}
